import React from "react";
import Feedback from "../../Common/feedback/Feedback";
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";

const FeedbackPage = () => {
  return (
    <ResponsiveContentWrapper>
      <Feedback />
    </ResponsiveContentWrapper>
  );
};

export default FeedbackPage;
